import { AccessControlProfile } from '@/features/access-control-profiles/api/types/access-control-profile';
import { DiscountTemplate } from '@/features/hosts/api/types/discount';
import { Host } from '@/features/hosts/api/types/host';
import { VisitSource } from '@/features/visitors/api/types/visitor';

export interface Visit {
  id: string;
  createdAt: Date | string;
  description?: string;
  updatedAt: Date | string;
  deletedAt: Date | string;
  kioskEnteredHostName?: string | null;
  state: VisitState;
  mainDestination: Destination;
  additionalDestinations: Destination[];
  host: Host;
  visitors: Visitor[];
  expectedAt: string;
  finishesAt: string;
  arrivedAt: string;
  leftAt: string;
  processableUntil: string;
  numberOfVisitors: number;
  visitFinishReason: VisitFinishReason;
  source: VisitSource;
  hostConfirmed: boolean | null;
  deviceConfirmed: boolean | null;
  category: {
    en: string;
    pl: string;
  };
}

export interface Destination {
  id: number;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt: Date | string;
  name: string;
  description: string;
  floor: number;
  directionTip: string;
  maxCapacity: number;
  accessBeforeVisitInMinutes: number;
  accessAfterVisitInMinutes: number;
  accessControlProfiles: AccessControlProfile[];
}

export enum ParkingTicketState {
  ASSIGNED = 'assigned',
  DISCOUNTED = 'discounted',
  DISCOUNT_ERROR = 'discount_error',
}

export interface ParkingTicket {
  id: number;
  status: ParkingTicketState;
  /** ISO 8601 date string */
  createdAt: string;
  /** ISO 8601 date string */
  updatedAt: string;
  ticketNumber: string;
  description: string | null;
}

export enum VisitorState {
  INVITED = 'invited',
  ARRIVED = 'arrived',
  LEFT = 'left',
  CANCELLED = 'cancelled',
  AWAITING_APPROVAL = 'awaiting_approval',
}

export interface Visitor {
  id: number;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt: Date | string;
  firstName: string;
  lastName: string;
  email: string;
  state: VisitorState;
  isHandicapped: boolean;
  isPregnant: boolean;
  hasAccessToParking: boolean;
  vehicleLicensePlateNumber: number;
  discountTemplate: DiscountTemplate | null;
  parkingTicket: ParkingTicket | null;
  description?: string;
}

export interface VisitsResponse {
  limit: number;
  offset: number;
  total: number;
  resources: Visit[];
}

export enum VisitState {
  CREATED = 'created',
  STARTED = 'started',
  CANCELLED = 'cancelled',
  FINISHED = 'finished',
  REJECTED = 'rejected',
}

export interface VisitLog {
  direction: 'in' | 'out';
  badgeType: string;
  badgeToken: string;
  occurredAt: string;
  entranceId: string;
  deviceId: string;
  occurredUsingMainEntrance: boolean;
  accessControlId: string;
}

export enum VisitFinishReason {
  MANUAL = 'manual',
  AUTOMATIC_VISITORS_LEFT_BUILDING = 'automatic_visitors_left_building',
  AUTOMATIC_TIME_FINISHED = 'automatic_time_finished',
}

export enum VisitFinishSetting {
  TIME_ENDS = 'time_ends',
  VISITORS_LEFT = 'visitors_left',
}

export enum VisitorNotificationMethod {
  EMAIL = 'email',
}
